import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useHistory, useRouteMatch , useLocation} from "react-router-dom";

type ButtonData = {
  label: string;
  icon: ({ isActive, ...props }: SvgIconProps) => JSX.Element;
};
interface IProps {
  ButtonData1: ButtonData;
  ButtonData2: ButtonData;
  url1: string;
  url2: string;
}

export const ToggleButton = ({
  ButtonData1,
  ButtonData2,
  url1,
  url2,
}: IProps) => {
  const history = useHistory();
  const { url } = useRouteMatch();
  const [enabled, setEnabled] = useState(false);
  const location = useLocation();
  const lastSegment = location.pathname.split("/").pop();


  
  
  

  useEffect(() => {
    if (lastSegment === 'data') {
      history.push(`${url}/${url2}`);
    } else history.push(`${url}/${url1}`);
    return () => {};
  }, [enabled,lastSegment, history, url, url1, url2]);

  useEffect(() => {
    if (lastSegment === 'data') {
      setEnabled(true)
    } else setEnabled(false)
    return () => {};
  }, [lastSegment]);
 

  return (
    <ToggleContainer enabled={enabled}>
      <Button1 enabled={enabled} onClick={() =>
        { 
          // setEnabled(!enabled )
          history.push(`${url}/${url1}`);
        }  
        }>
        {<ButtonData1.icon isActive={lastSegment === 'summary'} />}
        {!enabled && <Label>{ButtonData1.label}</Label>}
      </Button1>
      <Button2 enabled={enabled} onClick={() => { 
          // setEnabled(!enabled )
          history.push(`${url}/${url2}`);
        }  }>
        <ButtonData2.icon isActive={enabled} />
        {enabled && <Label>{ButtonData2.label}</Label>}
      </Button2>
    </ToggleContainer>
  );
};

const ToggleContainer = styled.div<{ enabled: boolean }>`
  display: grid;
  grid-template-columns: ${(props) =>
    props.enabled ? "4em auto" : "auto 4em"};
  margin-right: 1em;
`;

const Button1 = styled.button<{ enabled: boolean }>`
  font-size: 12;
  font-weight: 700;
  align-items: center;
  background-color: ${(props) => (!props.enabled ? "#ffff" : "#ebefff")};
  color: #01A8CE;
  padding: 1em 1.5em 1em 1.5em;
  margin-right: ${(props) => !props.enabled && "-3px"};
  border-top-left-radius: 0.5em;
  border-bottom-left-radius: 0.5em;
  border-top-right-radius: ${(props) => props.enabled && "0.5em"};
  border-bottom-right-radius: ${(props) => props.enabled && "0.5em"};
  border-left: 1px;
  border-top: 1px;
  border-bottom: 1px;
  border-color: ${(props) =>
    !props.enabled ? "rgba(1,168,206,1)" : "none"};
  border-right-style: none;
  border-left-style: ${(props) => (!props.enabled ? "solid" : "none")};
  border-top-style: ${(props) => (!props.enabled ? "solid" : "none")};
  border-bottom-style: ${(props) => (!props.enabled ? "solid" : "none")};
  &:focus {
    outline: none;
  }
`;

const Button2 = styled.button<{ enabled: boolean }>`
  font-size: 12;
  font-weight: 700;
  align-items: center;
  background-color: ${(props) => (props.enabled ? "#ffff" : "#ebefff")};
  color: #01A8CE;
  padding: 1em 1.5em 1em 1.5em;
  margin-left: ${(props) => props.enabled && "-3px"};
  border-top-right-radius: 0.5em;
  border-bottom-right-radius: 0.5em;
  border-top-left-radius: ${(props) => !props.enabled && "0.5em"};
  border-bottom-left-radius: ${(props) => !props.enabled && "0.5em"};
  border-right: 1px;
  border-top: 1px;
  border-bottom: 1px;
  border-color: ${(props) =>
    props.enabled ? "rgba(1,168,206,1)" : "none"};
  border-left-style: none;
  border-right-style: ${(props) => (props.enabled ? "solid" : "none")};
  border-top-style: ${(props) => (props.enabled ? "solid" : "none")};
  border-bottom-style: ${(props) => (props.enabled ? "solid" : "none")};
  &:focus {
    outline: none;
  }
`;

const Label = styled.label`
  text-align: center;
  color: #01A8CE;
  margin-left: 1em;
  vertical-align: top;
  font-size: 12;
`;
